import { BuscarPromoCidade, BuscarPromoCidadeTabelaPreco, BuscarTabelaPrecoAdesaoTodas, BuscarPromoCidadePlanoTabelaPreco } from '../../services/tabelaPrecoApi';

export async function getNomeCidade(exato, tipo, value) {
    const result = await BuscarPromoCidade(exato, tipo, value);

    if (result.resultado) {
        const newData = result.resultado[0];

        if (newData && newData.CidadesIBGE) {
            return newData.CidadesIBGE['NOME'];
        }
    }
}

export async function tabelaPrecoPromocao(exato, tipo, value, plano, subGrupo, pagina) {
    const result = await BuscarPromoCidadeTabelaPreco(exato, plano, value, tipo, subGrupo, pagina);

    return result;
}

export async function tabelaPrecoAdesaoTodas(pagina) {
    const result = await BuscarTabelaPrecoAdesaoTodas(pagina);

    return result;
}

export async function BuscaPlanoTabelaPreco(pagina) {
    const result = await BuscarPromoCidadePlanoTabelaPreco(pagina);

    return result;
}
